export type PromptBadgeVariant = 'most' | 'recommended';

export interface PromptRecommendationBadge {
  label: string;
  variant: PromptBadgeVariant;
}

export function tierFromIndexForBadge(index: number): PromptBadgeVariant | null {
  if (index === 0) return 'most';
  if (index >= 1 && index <= 3) return 'recommended';
  return null;
}

/** First prompt = Most Recommended; next three = Recommended; rest = no badge. */
export function getPromptRecommendationBadge(index: number): PromptRecommendationBadge | null {
  const tier = tierFromIndexForBadge(index);
  if (tier === 'most') {
    return { label: 'Most Recommended', variant: 'most' };
  }
  if (tier === 'recommended') {
    return { label: 'Recommended', variant: 'recommended' };
  }
  return null;
}

export function badgeFromPromptTier(
  tier: PromptBadgeVariant | null | undefined
): PromptRecommendationBadge | null {
  if (tier === 'most') {
    return { label: 'Most Recommended', variant: 'most' };
  }
  if (tier === 'recommended') {
    return { label: 'Recommended', variant: 'recommended' };
  }
  return null;
}
